export default __webpack_public_path__ + "static/media/w6.9b68b7ed.png";